import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { useCommonStore } from '@/js/lib/store/common';

const KEY = 'close-app-download-banner';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppDownloadBanner',
  setup(__props) {

const commonStore = useCommonStore();
const isShow = ref(!getFromStorage({ key: KEY }) && !commonStore.isWebView);
const sendEvent = () => {
  window.dataLayer?.push({
    event: 'app_banner_click',
  });
};
const onClose = () => {
  isShow.value = false;
  setToStorage({ key: KEY, value: true, expirationSeconds: -1 });
};

return (_ctx: any,_cache: any) => {
  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "https://www.iichi.com/app",
          class: _normalizeClass(_ctx.$style.banner),
          onClick: sendEvent
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.$style.close),
            onClick: _withModifiers(onClose, ["prevent"])
          }, "×", 2),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.logo)
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: "https://cdn.iichi.com/site/images/ui/logo/header-logo.png",
              alt: "iichi",
              width: "34",
              height: "14"
            }, null, -1)
          ]), 2),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.text)
          }, _cache[1] || (_cache[1] = [
            _createTextVNode("iichi公式アプリ"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("アプリ限定クーポン配布中！")
          ]), 2),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.$style.download)
          }, "ダウンロード", 2)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})